"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcIsLastGroup = void 0;
function calcIsLastGroup(totalCountForNode, node, hideEmptyGroups = false) {
    if (!node.parentNode)
        return false;
    let siblings = node.parentNode.childNodes;
    if (hideEmptyGroups)
        siblings = siblings.filter(v => totalCountForNode.get(v) > 0);
    const noSiblings = siblings.length;
    return node === siblings[noSiblings - 1];
}
exports.calcIsLastGroup = calcIsLastGroup;
exports.default = calcIsLastGroup;
